import React, { useState } from 'react';
import TakeQuiz from './takequiz';
import QuizFrontend from './quizfrontend';
import Student_Sidebar from '../component/Sidebar_student';
import '../assets/css/buttongradient.css';

const QuizRouter = () => {
  const [selectedQuiz, setSelectedQuiz] = useState(null);
  const handleStartQuiz = (quiz) => {
    setSelectedQuiz(quiz);
  };

  return (
    <div
  className="flex relative bg-cover bg-center bg-fixed bg-opacity-50 backdrop-blur-lg"
  style={{
    backgroundImage: `url(https://ik.imagekit.io/growthx100/24240507_6898809.jpg?updatedAt=1715086918840)`,
  }}
>
  {/* Sidebar */}
  <div className="w-72 fixed sidebar bg-custom-sidebar bg-opacity-50 backdrop-blur-sm min-h-screen">
    <Student_Sidebar />
  </div>

  {/* Main Content */}
  <div className="ml-72 flex-1 min-h-screen">
    {/* Here is main content */}
    <div className="container mx-auto p-4 relative z-10 ">
      {!selectedQuiz ? (
        <TakeQuiz onStartQuiz={handleStartQuiz} />
      ) : (
        <QuizFrontend quiz={selectedQuiz} />
      )}
    </div>
  </div>
</div>
  );
};

export default QuizRouter;
